import React from 'react';

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  fill?: 0 | 1;
  style?: React.CSSProperties;
}

/** Material Symbols Outlined 아이콘 헬퍼 */
export default function Icon({ name, size = 20, color, fill, style }: IconProps) {
  return (
    <span
      style={{
        fontFamily: "'Material Symbols Outlined'",
        fontSize: `${size}px`,
        color,
        fontVariationSettings: fill !== undefined ? `'FILL' ${fill}` : undefined,
        lineHeight: 1,
        display: 'inline-block',
        userSelect: 'none',
        flexShrink: 0,
        ...style,
      }}
    >
      {name}
    </span>
  );
}
